import { ConversationalChatVisibility } from '@klant/conversational-connector/klant-conversational-connector.model';
import { ConversationalChatStore } from 'src/signal-stores/conversational-chat-store/conversational-chat.store';

import { Component, computed, ElementRef, inject } from '@angular/core';

import { DebugUtilsService } from '../../../../debug/debug-utils.service';
import { ConversationalConfigStore } from '../../../signal-stores/conversational-config-store/conversational-config.store';

/**
 * @module WrapperModule
 * @ngdoc component
 * @name WrapperComponent
 */
@Component({
    selector: 'wrapper',
    templateUrl: './wrapper.component.html',
    standalone: false
})
export class WrapperComponent {
    private readonly conversationalChatStore = inject(ConversationalChatStore);
    private readonly conversationalConfigStore = inject(ConversationalConfigStore);
    private readonly debugUtilsService = inject(DebugUtilsService);
    private readonly elementRef = inject(ElementRef);

    public readonly errorTriggered = computed(() => this.conversationalConfigStore.shouldTriggerErrorOnMijnContactPage() === true);
    public readonly currentEnv = computed(() => this.conversationalConfigStore.seamlyConfiguration().environment);

    public openChat(): void {
        this.conversationalChatStore.setChatVisibility(ConversationalChatVisibility.OPEN);
    }

    public sendTestMessage(message: string) {
        if (this.conversationalChatStore.chatVisibility() !== ConversationalChatVisibility.OPEN) {
            this.openChat();
        }

        const testMessageToChat = new CustomEvent('chatMessage', {
            bubbles: true,
            detail: { chatMessage: message }
        });

        this.elementRef.nativeElement.dispatchEvent(testMessageToChat);
    }

    public toggleEnv(): void {
        this.debugUtilsService.toggleEnvironment(this.currentEnv());
    }
}
